var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({staticClass:"dfield-search",attrs:{"prepend-inner-icon":"$search","color":"secondary","outlined":"","filled":"","solo":"","flat":"","dense":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }